import React from "react";

const ExperienceSection = () => {
  const experiences = [
    {
      company: "WYSWYG Solutions",
      position: "FullStack Developer Intern",
      period: "Feb 2024 – May 2024",
      description:
        "Designing smooth user interfaces and flows for a low-code/no-code AI agent platform. Improved UI/UX, fixed frontend bugs, and contributed to SaaS landing page designs while ensuring clean, accessible, and fast iterative designs.",
    },
    {
      company: "Elivatics",
      position: "FullStack Developer",
      period: "Dec 2024 – Present",
      description:
        "Contributed to the development and deployment of MBBS Routes, a live MBBS consultation platform with over 1,200+ registered students. Worked on end-to-end features including responsive dashboard UI, backend integration, AWS EC2 deployment, Route 53 domain configuration, and MongoDB database management.",
    },
  ];

  return (
    <section className="py-16 px-4 lg:px-6 md:px-10">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-4xl font-bold mb-12 text-black dark:text-white">
          Experience
        </h2>

        <div className="space-y-8">
          {experiences.map((exp, index) => (
            <div
              key={index}
              className="border-t border-gray-200 dark:border-gray-700 pt-8"
            >
              <div className="grid md:grid-cols-3 gap-6">
                <div className="md:col-span-1">
                  <p className="text-gray-600 dark:text-gray-400 text-sm mb-2">
                    {exp.company}
                  </p>
                  <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
                    {exp.position}
                  </h3>
                </div>

                <div className="md:col-span-2">
                  <p className="text-gray-700 dark:text-gray-300 mb-4">
                    {exp.description}
                  </p>
                  <p className="text-gray-500 dark:text-gray-400 text-sm">
                    {exp.period}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;
